export const ShopPage = () => {
    return <p>Shop page</p>
}
